import { render } from "./GutenbergHandler.vue?vue&type=template&id=0812a95c"
import script from "./GutenbergHandler.vue?vue&type=script&lang=js"
export * from "./GutenbergHandler.vue?vue&type=script&lang=js"

import "./GutenbergHandler.vue?vue&type=style&index=0&id=0812a95c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__